import { render, staticRenderFns } from "./AdminRules.vue?vue&type=template&id=a37cd21a&scoped=true&"
import script from "./AdminRules.vue?vue&type=script&lang=js&"
export * from "./AdminRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37cd21a",
  null
  
)

export default component.exports